import styled from "styled-components"
import Container from "components/layout/Container"
import { Offcanvas } from "react-bootstrap"
import { Box, Flex } from "components/Box"
import { FlexComponentSpaceBetween } from "components/Box/AllFlexComponentStyle"
// import { Button } from "components/Button"
import SettingButton from 'assets/Buttons/SettingButton.svg'
import { Link } from "react-router-dom"
import SignUpFill from 'assets/Buttons/SignUpFill.svg'

export const HeaderFixed = styled(Box)`
	background-color: #030B1E;
	// ${({ theme }) => theme.mediaQueries.xs} {
    // }
	// ${({ theme }) => theme.mediaQueries.md} {
	// background-color: #050b20;
	// 	height: 90px;
	// 	position: fixed;
	// 	z-index: 2;
	// 	left: 0;
	// 	right: 0;
	// 	box-shadow: 5px 5px 5px 1px rgb(2, 5, 46);
	// 	display: flex;
	// 	align-items: center;
    // }
`

export const HeaderMenuStyling = styled(Flex)`
	justify-content: center;
	align-items: center;
	ul { 
		list-style: none; 
		margin: 0;
		padding: 0;
	}
	li { 
		position: relative; 
	}
	a {
		color: ${(props) => props.theme.colors.text};
		margin: 0px 14px;
		text-decoration:none;
		cursor: pointer;
		align-items: center;
		display: flex;
		font-weight: 400;
		font-size: 18px;
		line-height: 26px;
		position: relative;
	}
	a:after {    
		background: none repeat scroll 0 0 transparent;
		bottom: 0;
		content: "";
		display: block;
		height: 2px;
		left: 50%;
		position: absolute;
		background: ${(props) => props.theme.colors.text};
		transition: width 0.3s ease 0s, left 0.3s ease 0s;
		width: 0;
	}
	a:hover:after { 
		width: 100%; 
		left: 0;
	}
	a:active:after { 
		width: 100%; 
		left: 0;
	}
`

export const NavLink = styled(Link)`
	color: ${(props) => props.theme.colors.text};
	margin: 0px 14px;
	text-decoration: none;
	cursor:pointer;
	font-weight: 400;
	font-size: 18px;
	line-height: 26px;
	display: flex;
	:hover{
		color: ${(props) => props.theme.colors.primary};
	}
`

export const HeaderNavLink = styled(`a`)`
	color: ${(props) => props.theme.colors.text};
	margin: 0px 14px;
	text-decoration: none;
	cursor:pointer;
	font-weight: 400;
	font-size: 18px;
	line-height: 26px;
	display: flex;
	:hover{
		color: ${(props) => props.theme.colors.primary};
	}
`

export const NavLinkLoginButton = styled(Flex)`
	color: ${(props) => props.theme.colors.primary};
	font-weight: 400;
	line-height: 25px;
	font-style: normal;
    background-image: url("./newAssets/Buttons/LoginUnFill.png");
	background-repeat: no-repeat;
	background-size: cover;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	cursor: pointer;
	${({ theme }) => theme.mediaQueries.xs} {
		padding: 5px 20px;
    }
	${({ theme }) => theme.mediaQueries.md} {
		width: 120px;
		height: 50px;
    }
`

export const HeaderSignupButton = styled(Flex)`
	color: ${(props) => props.theme.colors.text};
	font-weight: 400;
	line-height: 25px;
	font-style: normal;
    background-image: url(${SignUpFill});
	background-repeat: no-repeat;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	cursor: pointer;
	${({ theme }) => theme.mediaQueries.xs} {
		padding: 5px 25px;
		background-size: 100%;
		background-position: 100%;
    }
	${({ theme }) => theme.mediaQueries.md} {
		width: 120px;
		height: 50px;
    }
`
export const WithdrawWrapper = styled(Flex)`
	${NavLink}{
		margin: 0px 8px;
	}
`

export const WithdrawSettingIcon = styled(HeaderSignupButton)`
    background-image: url(${SettingButton});
	padding: unset;
	width: 50px;
`

export const WithdrawTextStyle = styled(NavLink)`
	& img{ 
		padding:0px 15px;
	}
`

export const NavbarSettingOffcanvasLaptop = styled(Container)`
	${({ theme }) => theme.mediaQueries.xs} {
		display: none;
    }
	${({ theme }) => theme.mediaQueries.md} {
		display: flex;
		// position: fixed;
		// z-index: 1;
		// left: 0;
		// right: 0;
		height: 120px;
    }
	${FlexComponentSpaceBetween}{
		flex-grow: 1;
		padding: 18px 0px;
	}
`

export const NavbarSettingOffcanvasMobileDisplay = styled(Container)` 
	${({ theme }) => theme.mediaQueries.xs} {
		display: block;
		padding: 20px 0px;
    }
	${({ theme }) => theme.mediaQueries.md} {
		display: none;
    }
`

export const OffcanvasMobileBody = styled(Box)` 
	margin: 50px auto;
`

export const OffcanvasMobileBackgroundWidth = styled(Offcanvas)` 
	background-color: ${(props) => props.theme.colors.primary};
	width:300px;
`

export const OffcanvasMenusBox = styled(Box)`
	padding: 20px 0px;
`

export const OffcanvasMenusLink = styled(WithdrawTextStyle)`
	padding: 15px 0px;
	font-weight: 500;
`

export const HeaderDashboardStyle = styled(Flex)`
	border: 2px solid ${(props) => props.theme.colors.primary};
	border-radius: 10px;
`

export const HeaderRegisterLogoMobileScreenStyle = styled(Flex)`
	${({ theme }) => theme.mediaQueries.xs} {
		justify-content: center;
		margin: 50px 0px;
    }
	${({ theme }) => theme.mediaQueries.sm} {
		justify-content: left;
		margin: unset;
    }
`

export const HeaderRegisterMenubarStyle = styled(Box)`
	${({ theme }) => theme.mediaQueries.xs} {
    }
	${({ theme }) => theme.mediaQueries.md} {
		background-color: ${(props) => props.theme.colors.imgBackgroundColor};
		height: 90px;
		position: fixed;
		z-index: 1;
		left: 0;
		right: 0;
		box-shadow: 5px 5px 5px 1px rgb(2, 5, 46);
		display: flex;
		align-items: center;
    }
`

export const PrimaryHeaderLogo = styled(Box)`
	& img{
		width: 164px;
		height: 64px;
	}
`